import React, { useEffect, useState } from 'react';
import { StanModal } from '@/components';
import { cn } from '@/lib';
import { ImagePreviewModalProps } from '../types/fileAttachments.types';

export const ImagePreviewModal: React.FC<ImagePreviewModalProps> = ({
    isOpen,
    imageSrc,
    imageAlt,
    filename,
    onClose,
    className = '',
    onError,
}) => {
    const [imageError, setImageError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    // Reset states when modal opens or image source changes
    useEffect(() => {
        if (isOpen && imageSrc) {
            setImageError(false);
            setIsLoading(true);
        }
    }, [isOpen, imageSrc]);

    const handleImageLoad = () => {
        setIsLoading(false);
        setImageError(false);
    };

    const handleImageError = () => {
        setIsLoading(false);
        setImageError(true);
        if (onError) {
            onError(new Error('Failed to load image'));
        }
    };

    return (
        <StanModal
            id='image-preview-modal'
            isOpen={isOpen}
            onClose={onClose}
            title={filename}
            size='xl'
            className={className}
        >
            <div className='flex min-h-[400px] items-center justify-center'>
                {isLoading && !imageError && (
                    <div className='flex items-center justify-center'>
                        <div className='border-t-brand-main border-subtle size-8 animate-spin rounded-full border-4' />
                    </div>
                )}
                {imageError ? (
                    <div className='text-gray flex flex-col items-center justify-center py-12'>
                        <p className='body-md'>Failed to load image</p>
                    </div>
                ) : (
                    <img
                        src={imageSrc}
                        alt={imageAlt}
                        className={cn(
                            'max-h-[70vh] max-w-full rounded-lg object-contain',
                            isLoading ? 'hidden' : 'block'
                        )}
                        onLoad={handleImageLoad}
                        onError={handleImageError}
                    />
                )}
            </div>
        </StanModal>
    );
};
